import React, { useMemo } from 'react'

import { IHomeType, IPageType } from '@/types'
import { useLanguages } from '@/hooks'

import GlobeIcon from '@/assets/img/globe.svg'
import StarsIcon from '@/assets/img/stars.svg'
import SupportIcon from '@/assets/img/support.svg'
import VehicleIcon from '@/assets/img/vehicle.svg'
import LocationsIcon from '@/assets/img/locations.svg'
import NotAllowedIcon from '@/assets/img/not-allowed.svg'

const advantages: {
  className: string
  Icon: React.ElementType
}[] = [
  {
    Icon: StarsIcon,
    className: 'theme--green',
  },
  {
    Icon: LocationsIcon,
    className: 'theme--pink',
  },
  {
    Icon: VehicleIcon,
    className: 'theme--orange',
  },
  {
    Icon: SupportIcon,
    className: 'theme--light-blue',
  },
  {
    Icon: NotAllowedIcon,
    className: 'theme--purple',
  },
  {
    Icon: GlobeIcon,
    className: 'theme--dark-blue',
  },
]

export const AdvantagesSection: React.FC<IPageType<IHomeType>> = ({
  template,
}) => {
  const { t } = useLanguages()

  const labels = useMemo(
    () => template?.advantages?.split(','),
    [template?.advantages],
  )

  return (
    <section className="padding-vertical--small">
      <div className="row">
        <h2 style={{ marginBottom: '15px' }}>{t('advantages')}</h2>
      </div>
      <div className="row">
        {advantages.map((advantage, idx) => (
          <div key={idx} className="column small-12 medium-4">
            <div className="flex-container align-middle advatage_item">
              <div className={advantage.className}>
                <advantage.Icon />
              </div>
              {/* @ts-ignore */}
              <h3>{labels?.[idx] ?? ''}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
